import axios from "axios"
import { handleError } from "../Helpers/ErrorHandler"
import { BikeModel } from "../Models/BikeModel";
import { UserBikeModel } from "../Models/UserBikeModel";
import { MTB_PART_PICKER_API } from "../constants";
import { GeometryModel } from "../Models/GeometryModel";

export const searchBikeAPI = async (make: string, model: string, year: string) => {
    let searchedBike: BikeModel = {
        id: 0,
        make: "",
        model: "",
        year: "",
        image_url: ""
    }
    try {
        const data = await axios.post<UserBikeModel>(MTB_PART_PICKER_API + "/BikeSearch", {
            make: make,
            model: model,
            year: year
        })
        if (data) {
            searchedBike.id = data.data.id;
            searchedBike.make = data.data.make;
            searchedBike.model = data.data.model;
            searchedBike.year = data.data.year;
            searchedBike.image_url = data.data.image_url;
            }

        return searchedBike;
    } catch (error) {
        handleError(error)
    }
};

export const saveUserBikeAPI = async (bike_id: number) => {
    try {
        const data = await axios.post<UserBikeModel>(MTB_PART_PICKER_API + `/Garage?id=${bike_id}`);

        return data;
    } catch (error) {
        handleError(error)
    }

};

export const deleteUserBikeAPI = async (bike_id: number) => {
    try {
        const data = await axios.delete<UserBikeModel>(MTB_PART_PICKER_API + `/Garage?id=${bike_id}`);
        return data;
    } catch (error) {
        handleError(error)
    }

};

export const getUserBikesAPI = async (id: string) => {
    try {
        const data = await axios.get<UserBikeModel[]>(MTB_PART_PICKER_API + `/Garage?id=${id}`);
        return data;
    } catch (error) {
        handleError(error)
    }
};


export const getBikeMakesAPI = async () => {
    try {
        const data = await axios.get<{bike_col: string}[]>(MTB_PART_PICKER_API + "/Bike/GetMakes");
        if (data){
            return data;
        }
    } catch (error) {
        handleError(error)
        return null;
    }
};

export const getBikeModelsAPI = async (make: string) => {
    try {
        const data = await axios.get<{bike_col: string}[]>(MTB_PART_PICKER_API + `/Bike/${make}`);
        if (data){
            return data;
        }
    } catch (error) {
        handleError(error)
    }
};

export const getBikeYearAPI = async (make: string, model: string) => {
    try {
        const data = await axios.get<{bike_col: string}[]>( MTB_PART_PICKER_API + `/Bike/GetColumnYear?make=${make}&model=${model}`);
        if (data){
            return data;
        }
    } catch (error) {
        handleError(error)
    }
};

export const getGeoAPI = async (id: number) => {
    try {
        const data = await axios.get<GeometryModel>(MTB_PART_PICKER_API + `/Geometry/${id}`)
        if (data) {
            return data;
        }
    } catch (error) {
        handleError(error)
    }
};

export const getSpecsAPI = async (id: number) => {
    try {
        const data = await axios.get<GeometryModel>(MTB_PART_PICKER_API + `/Specifications/${id}`)
        if (data){
          return data;  
        }
    } catch (error) {
        handleError(error)
    }
};